import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForReporting extends RoutePathBuilder {
    dashboard(slug: string) {
        return this.url(slug);
    }
}
